import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class LogoEmpresaService {

  PATH = new ConfigService().obtenerPath();

  constructor(
    private http : Http,
    private _key : KeyService
  ) { }

 
  /**
   * Enviar registros de los logos
   * JACP-2018-10-18
   */
  enviarLogos(logos:any){
    let url = this.PATH + '/api/admin/logo';
    return this.http.post(url, logos, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Editar registros de los logos
   * JACP-2018-10-18
   */
  editarLogos(logos:any){
    let url = this.PATH+'/api/admin/logo/'+logos.id; 
    return this.http.put(url, logos, {headers:this._key.head()}).map( resp => resp.json()); 
  }

  /**
   * Cargar registros de los logos
   * JACP-2018-10-19
   */
  cargarLogos(){ 
    let url = this.PATH + '/api/admin/logo';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener un registro por id de un logo para editar
   * JACP-2018-10-19
   */
  getRegLogos(id:any)
  {
    let url = this.PATH + '/api/admin/logo/'+id+'/edit'; 
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Eliminar logo
   * JACP-2018-10-19
   */
  destroylogo(id:any)
  {
    let url = this.PATH + '/api/admin/logo/'+id+'/destroy';
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());        
  }// .destroylogo(id:any)

   
  /**
   * Enviar registros de la empresa
   * JACP-2018-10-18
   */
  submitEmpresa(dataEmpresa){
    let url = this.PATH + '/api/admin/submitEmpresa';
    return this.http.post(url, dataEmpresa, {headers:this._key.head()}).map(resp => resp.json());
  }

    /**
   * OBTENER DATOS LA EMPRESA
   * CAAA-2019-08-05
   */
  getEmpresa()
  {
    let url = this.PATH + '/api/admin/getEmpresa';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getMarcas()


}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/logo-empresa/logo-empresa.service.ts